import { Route, Routes } from "react-router-dom";
import AdminOverview from "./pages/Overview";
import Logs from "./pages/Logs";
import Member from "./pages/admin/Member.admin";
import PhoneNumberDetailAdmin from "./pages/admin/PhoneNumberDetail.admin";
import CreateAssistant from "./pages/CreateAssistant";
import AssistantDetails from "./pages/Assistant/AssistantDetails";
import ViewAssistantTemplate from "./pages/ViewAssistantTemplate"
import BuyCallingMinutes from "./pages/BuyCallingMinutes";
import Assistants from "./pages/Assistants";
import NotFound from "./pages/NotFound";
import MaintenancePage from "./pages/maintenancePage"; 
import { useMaintenanceRedirect } from "../src/hooks/useMaintenanceRedirect";
import PhoneNumber from "./pages/PhoneNumber";

export const AdminRoutes = () => {
  const redirect = useMaintenanceRedirect();
  if (redirect) return redirect;

    return (
        <Routes>
            {/* <Route path="*" element={<AdminOverview />} /> */}
            <Route path="/maintenance" element={<MaintenancePage />} />
            <Route path="/company/:company_id/overview" element={<AdminOverview />} />
            {/* <Route path="/company/:company_id/assistants" element={<AdminAssistant />} /> */}
            <Route path="/company/:company_id/assistants" element={<Assistants />} />
            <Route path="/company/:company_id/assistants/create" element={<CreateAssistant />} />
            <Route path="/company/:company_id/phone-number" element={<PhoneNumber />} />
            <Route path="/company/:company_id/logs" element={<Logs />} />
            <Route path="/company/:company_id/member" element={<Member />} />
                    {/* <Route path="/company/:company_id/assistant/:id" element={<AssistantDetailAdmin />} /> */}
            <Route path="/company/:company_id/assistant/:assistantId" element={<AssistantDetails />} />
            <Route path="/company/:company_id/phone-number/:id" element={<PhoneNumberDetailAdmin />} />
            <Route path="/company/:company_id/view-assistant/:id" element={<ViewAssistantTemplate />} />
            <Route path="/company/:company_id/credits" element={<BuyCallingMinutes />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
